export const MERGE_TAGS = ["First Name", "Brand Name"];

export const DAYS_TO_DELAY_FOLLOWUP = 4;
export const MAXIMUM_FOLLOWUP_ALLOWED = 3;
export const MAXIMUM_BULK_AI_MESSAGES_ALLOWED = 20;
export const LAST_USED_TEMPLATE = "lastUsedTemplate";
